module.exports = __webpack_public_path__ + "img/truckRearLeft.9541489d.svg";